<template>
    <div class="card">
        <div class="card-header">Personal & Contact Information</div>
        <div class="card-body" v-if="!!workDatesApplication">
            <b-row>
                <b-col cols="4"><BaseTextOutput label="Last Name" :value="workDatesApplication.lastName"/></b-col>
                <b-col cols="4"><BaseTextOutput label="First Name" :value="workDatesApplication.firstName"/></b-col>
                <b-col cols="4"><BaseTextOutput label="Middle Name" :value="workDatesApplication.middleName"/></b-col>
            </b-row>
            <b-row>
                <b-col cols="4"><BaseTextOutput label="Social Security Number" :value="workDatesApplication.license.socialSecurityNumber"/></b-col>
                <b-col cols="4"><BaseTextOutput label="Date of Birth" :value="workDatesApplication.license.dateOfBirth"/></b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <BaseMaskedTextInput v-model="workDatesApplication.preferredPhone"
                                         :v="$v.workDatesApplication.preferredPhone"
                                         slug="preferredPhone"
                                         label="Preferred Phone"
                                         setId="preferredPhone"
                                         mask="(###)###-####"
                    />
                </b-col>
                <b-col cols="4">
                    <BaseTextInput v-model="workDatesApplication.emailAddress"
                                   :v="$v.workDatesApplication.emailAddress"
                                   slug="emailAddress"
                                   label="Email Address"
                                   setId="applEmailAddress"
                    />
                </b-col>
            </b-row>
        </div>
    </div>

</template>
<script>
    import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
    import BaseMaskedTextInput from '@/components/templates/input/BaseMaskedTextInput.vue'
    import { required, requiredIf, minLength, email } from 'vuelidate/lib/validators'
    import axiosRetry from 'axios-retry'
    import axios from "axios"

    export default {
        props: {
            workDatesApplication: {
                type: Object,
                default () {
                    return {
                        preferredPhone: null,
                        emailAddress: null,
                    }
                }
            }
        },
        data: () => {
            return {
            }
        },
        components: {
            BaseTextInput,
            BaseMaskedTextInput
        },
        validations() {
            return {
                workDatesApplication: {
                    preferredPhone: { required, minLength: minLength(13) },
                    emailAddress: { required, email },
                },
                form: [ 'workDatesApplication' ]
            }
        },
        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },
        },
    }
</script>
